<script setup>
import {defineProps, useSlots, ref, onMounted} from 'vue'
import CodeInset from '@/components/InlineCode.vue'
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

let slots = useSlots()
const props = defineProps({
  title: String,
  method: String,
  json: {
    type: Boolean,
    default: false
  },
  text: {
    type: Boolean,
    default: false
  },
  raw: {
    type: Boolean,
    default: false
  },
  dark: {
    type: Boolean,
    default: false
  }
});

const data = ref(null)

if (props.json) {
  data.value = JSON.parse(slots.default()[0].children)
} else if (slots != undefined && slots != null) {
  if (slots.default != undefined) {
    data.value = slots.default()[0].children
  }
}

</script>

<template>
  <div class="block mb-3">
    <div class="title" :class="{'nobody': data == null || data == undefined, 'dark': props.dark}">
      <span v-if="method == 'GET'" class="method" style="color: var(--color-success-text);">{{method}}</span>
      <span v-if="method == 'POST'" class="method" style="color: var(--color-info-text);">{{method}}</span>
      {{ props.title }}
    </div>   
    <div class="content" v-if="data">
      <div v-if="props.text"><code>{{ slots.default()[0].children }}</code></div>
      <pre v-else-if="props.raw"><code>{{ slots.default()[0].children }}</code></pre>
      <vue-json-pretty v-else-if="props.json" :data="data" style="overflow: auto; max-height: 600px; color: white;"/>
      <code-inset v-else>
        <template v-for="(index, name) in $slots" v-slot:[name]>
          <slot :name="name" />
        </template>
      </code-inset>
    </div>   
  </div>
</template>

<style scoped>
pre {
  color: var(--text-heading);
}

code {
  color: var(--text-heading);
}

.block {
  border-radius: var(--radius-lg);
  background-color: var(--surface-sunken);
  overflow: hidden;
}


.method {
  font-weight: 600;
  font-size: .8rem;
  margin-right: .5rem;
}

.block .title {
  padding: .6rem .9rem;
  color: var(--text-secondary);
  font-size: var(--fs-sm);
  font-weight: 600;
  letter-spacing: 0.02em;
  border-bottom: 1px solid var(--border-subtle);
}

.block .content code,
.block .content pre {
  font-family: var(--font-heading);
  font-size: 0.85rem;
  color: var(--text-primary);
}

.block :deep(.vjs-tree) {
  font-family: var(--font-heading);
}

.dark {
  background-color: var(--surface-sunken) !important;
}

.nobody {
  border-bottom: none;
}

.block .content {
  padding: .9rem;
  overflow: auto;
}
</style>
